import { Button, Flex, Spacing, Text } from '@billy/design-system'
import { ReactElement, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { useIsTruncated } from '../../../../../../../../../../hooks'
import * as Styled from './styles'

interface EInvoiceCommentSectionProps {
  comment: string
}

export const EInvoiceCommentSection = ({ comment }: EInvoiceCommentSectionProps): ReactElement => {
  const [isExpanded, setIsExpanded] = useState(false)
  const { t } = useTranslation()
  const [commentTextRef, shouldShowToggle] = useIsTruncated(comment, 'vertical')

  const handleToggleClick = (): void => {
    setIsExpanded((previousIsExpanded) => !previousIsExpanded)
  }

  return (
    <Flex alignItems="flex-start" flexDirection="column" gap={Spacing.S4}>
      <Styled.CommentText isClamped={!isExpanded} ref={commentTextRef}>
        <Text as="span" variant="bodySM">
          {comment}
        </Text>
      </Styled.CommentText>

      {shouldShowToggle && (
        <Button aria-expanded={isExpanded} color="primary" onClick={handleToggleClick} size="sm" variant="text">
          {isExpanded
            ? t('external_invoices.view.sidebar.einvoice_details_card.read_less')
            : t('external_invoices.view.sidebar.einvoice_details_card.read_more')}
        </Button>
      )}
    </Flex>
  )
}
